export class Config {
    public static config: Object;
}


// WEBPACK FOOTER //
// ./app/config.ts